// V3 keeps legacy URLs wherever possible. Only retired/renamed routes need mapping.
const renamedPaths = {
  '/client-login': '/login',
  '/all-influencers': '/creators/search',
  '/influencers/social-data': '/influencers/audience-data',
  '/posts/published': '/posts/approved',
  '/posts/internal/published': '/posts/internal/approved'
}

export function getV3Origin(location) {
  if (location.hostname === 'localhost' || location.hostname === '127.0.0.1') {
    return location.protocol + '//' + location.hostname + ':3000'
  }
  return location.hostname === 'uat.app.getkobe.com'
    ? 'https://v3-uat.app.getkobe.com'
    : 'https://v3-app.getkobe.com'
}

export function getV3Url(route, location) {
  const path = route.path || '/'
  const normalizedPath = path.replace(/\/$/, '').toLowerCase() || '/'
  let targetPath = renamedPaths[normalizedPath] || path
  if (/^\/(?:co|am)\/dashboard(?:\/|$)/i.test(path)) {
    targetPath = '/dashboard'
  }
  const fullPath = route.fullPath || path
  const suffix = fullPath.slice(path.length)
  // Preserve filters, selected campaigns, public form parameters, and anchors.
  // Audience-only records now live in the consolidated Creator Database.
  if (normalizedPath === '/all-influencers') {
    const hashIndex = suffix.indexOf('#')
    const query = hashIndex < 0 ? suffix : suffix.slice(0, hashIndex)
    const hash = hashIndex < 0 ? '' : suffix.slice(hashIndex)
    const params = new URLSearchParams(query)
    params.set('view', 'audience')
    return getV3Origin(location) + targetPath + '?' + params.toString() + hash
  }
  return getV3Origin(location) + targetPath + suffix
}



// WEBPACK FOOTER //
// ./src/utils/v3Migration.js